import React from 'react';
import { rhTiers } from '../../../constants/RewardsHub';
import { ComponentHeading } from '../../shared/rewards-hub';
import { RewardsHubContext, RewardsAndOffersContext } from '../../../contexts';
import { BannerText } from '../RewardsHubBanner/RewardsHubBanner';
import { BENEFIT_LISTS } from './BenefitLists';
import { TIER_LEVELS, BenefitsHeaderContainer } from './Utils';
import { TopSavingsForYou } from '../../shared/rewards-hub/top-savings/top-savings-for-you';
var determineTierLists = function (membershipLevel) {
    switch (membershipLevel) {
        case TIER_LEVELS.ELITE:
            return {
                current: [
                    BENEFIT_LISTS.PERKOFFERS,
                    BENEFIT_LISTS.ELITE,
                    BENEFIT_LISTS.MEMBER,
                ],
                future: [BENEFIT_LISTS.VIP],
            };
        case TIER_LEVELS.VIP:
            return {
                current: [
                    BENEFIT_LISTS.PERKOFFERS,
                    BENEFIT_LISTS.VIP,
                    BENEFIT_LISTS.ELITE,
                    BENEFIT_LISTS.MEMBER,
                ],
                future: [],
            };
        default:
            return {
                current: [BENEFIT_LISTS.PERKOFFERS, BENEFIT_LISTS.MEMBER],
                future: [BENEFIT_LISTS.ELITE, BENEFIT_LISTS.VIP],
            };
    }
};
export var RewardTiers = function (_a) {
    var isMobile = _a.isMobile;
    var membershipLevel = React.useContext(RewardsHubContext).membershipLevel;
    var _b = determineTierLists(membershipLevel), current = _b.current, future = _b.future;
    // Get TopSavings values from RewardsAndOffersContext
    var _c = React.useContext(RewardsAndOffersContext), showTopSavingsAtTop = _c.showTopSavingsAtTop, showTopSavingsAtLast = _c.showTopSavingsAtLast;
    var listToRender = function (list, isLocked) {
        return list.map(function (Component, index) { return (React.createElement(Component, { key: index, isLocked: isLocked })); });
    };
    /**
     * Feature Switch Configuration: IS_TOP_SAVINGS
     *
     * T&T team controls TopSavings positioning through Rehub feature flag:
     * - IS_TOP_SAVINGS: 'top' = renders at top of RewardTiers
     * - IS_TOP_SAVINGS: 'middle' = renders within PerksOffersBenefits component
     * - IS_TOP_SAVINGS: 'last' = renders at bottom of RewardTiers
     * - IS_TOP_SAVINGS: 'off' = component not rendered (default)
     *
     * T&T uses: LAYOUT_MANAGER.ADD_FS trigger format
     * Component placement is controlled by T&T's A/B testing system
     */
    return (React.createElement("div", { className: "rewardsHub_page__RewardTiers sui-mb-6" },
        showTopSavingsAtTop && React.createElement(TopSavingsForYou, null),
        React.createElement(BenefitsHeaderContainer, { tierName: membershipLevel }),
        isMobile && React.createElement(BannerText, { isMobile: true }),
        listToRender(current, false),
        showTopSavingsAtLast && React.createElement(TopSavingsForYou, null),
        future.length > 0 && (React.createElement(React.Fragment, null,
            React.createElement(ComponentHeading, { isMobile: isMobile, titleArray: rhTiers.headingTitle, subtitle: rhTiers.headingSubtitle }),
            listToRender(future, true)))));
};
